// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"ActivityLoader_modalContainer__3zkTN"};